
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'ZAccordionItem',
  props: {
    title: {
      default: '',
      type: String
    },
    isOpen: {
      type: Boolean,
      default: false
    },
    isList: {
      type: Boolean,
      default: false
    },
    spanCustomHeight: {
      type: Boolean,
      default: false
    },
    customMaxHeight: {
      type: String,
      default: 'max-h-screen'
    },
    allowOverflow: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      open: this.isOpen,
      accordionHeaderAnimations: ''
    }
  },
  computed: {
    isDisabled(): boolean {
      // @ts-expect-error - TODO refactor to a render function which types correctly,`$parent` should be `ZAccordion`
      return this.$parent.disabled
    },
    showBorders(): boolean {
      // @ts-expect-error - TODO refactor to a render function which types correctly, `$parent` should be `ZAccordion`
      return this.$parent.showBorders
    }
  },
  watch: {
    isOpen() {
      this.toggleAccordion()
    }
  },
  methods: {
    toggleAccordion() {
      if (this.isDisabled) return
      if (this.isList) return
      this.open = !this.open
      this.accordionHeaderAnimations = this.open
        ? 'animate-first-quarter-spin rotate-90'
        : 'animate-reverse-quarter-spin rotate-0'
      this.$emit('isOpen', this.open)
    }
  }
})
